import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DBService {
  // Open DB
  async openIndexedDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('fptclientnotifications', 2);

      request.onupgradeneeded = function (event) {
        const db = event.target['result'];
        if (!db.objectStoreNames.contains('notifications')) {
          db.createObjectStore('notifications', {
            keyPath: 'id',
            autoIncrement: true,
          });
        }

        if (!db.objectStoreNames.contains('device_info')) {
          db.createObjectStore('device_info', {
          keyPath: 'deviceUuid',
    });
  }
      };

      request.onerror = function (event) {
        reject('IndexedDB error: ' + event.target['errorCode']);
      };

      request.onsuccess = function (event) {
        resolve(event.target['result']);
      };
    });
  }

  // Save in the DB with timestamp
  async saveNotificationData(data: any): Promise<void> {
    const db = await this.openIndexedDB();
    const transaction = db.transaction(['notifications'], 'readwrite');
    const store = transaction.objectStore('notifications');

    const notificationData = {
      ...data,
      receivedAt: new Date().toISOString(),
    };

    store.add(notificationData);

    return new Promise((resolve, reject) => {
      transaction.oncomplete = () => {
        db.close();
        resolve();
      };
      transaction.onerror = (error) => {
        reject(error);
      };
    });
  }

  // Get notifications from the DB
  async getNotifications(): Promise<any[]> {
    const db = await this.openIndexedDB();
    const transaction = db.transaction(['notifications'], 'readonly');
    const store = transaction.objectStore('notifications');
    const request = store.getAll();

    return new Promise((resolve, reject) => {
      request.onsuccess = (event) => {
        const allNotifications = event.target['result'];
        resolve(allNotifications);
      };
      request.onerror = (event) => {
        reject(event.target['error']);
      };
    });
  }

  //Delete notification
  async deleteNotification(id: number): Promise<void> {
    const db = await this.openIndexedDB();
    const transaction = db.transaction(['notifications'], 'readwrite');
    const store = transaction.objectStore('notifications');

    return new Promise((resolve, reject) => {
      const request = store.delete(id);

      request.onsuccess = () => {
        db.close();
        resolve();
      };

      request.onerror = (event) => {
        reject('Error deleting notification: ' + event.target['error']);
      };
    });
  }

  async saveDeviceInfo(info: any): Promise<void> {
  const db = await this.openIndexedDB();
  const transaction = db.transaction(['device_info'], 'readwrite');
  const store = transaction.objectStore('device_info');

  store.put(info); 

  return new Promise((resolve, reject) => {
    transaction.oncomplete = () => {
      db.close();
      resolve();
    };
    transaction.onerror = (error) => {
      reject(error);
    };
  });
}

async getDeviceInfo(): Promise<any | null> {
  const db = await this.openIndexedDB();
  const transaction = db.transaction(['device_info'], 'readonly');
  const store = transaction.objectStore('device_info');

  return new Promise((resolve, reject) => {
    const request = store.getAll(); 

    request.onsuccess = (event) => {
      const results = event.target['result'];
      if (results.length > 0) {
        resolve(results[0]);
      } else {
        resolve(null);
      }
    };

    request.onerror = (event) => {
      reject('Error fetching device info: ' + event.target['error']);
    };
  });
}


}
